import { createServerFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

import { auth } from "@/lib/auth";

export const $getUserSession = createServerFn({
	method: "GET",
}).handler(async () => {
	try {
		const headers = getRequestHeaders();
		// Ensure headers is a Headers object or compatible
		const sessionResponse = await auth.api.getSession({
			headers: headers,
		});

		return {
			session: sessionResponse?.session,
			user: sessionResponse?.user,
		};
	} catch (error) {
		console.error("Failed to get session:", error);
		// Return nulls instead of throwing to prevent crash
		return {
			session: null,
			user: null,
		};
	}
});
